import React from "react";

import { useHistory } from "react-router-dom";

import { LOGIN_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";
import Center from "@/tpo/Center";
import B2CHeader from "@/tpo/header/B2CHeader";
import ButtonV2 from "@/v2/Buttons";

import { CustomerAccountPage } from "./CustomerPage";
import Text from "./Text";

function SignupCompletePage() {
  useDocTitle("Signup complete");
  const history = useHistory();

  return (
    <>
      <B2CHeader />
      <CustomerAccountPage
        jumbotronProps={{
          title: "Account activated"
        }}
      >
        <Text>
          Your account has been successfully activated. Please click below to Sign in to your
          account.
        </Text>
        <Center>
          <ButtonV2
            color="green"
            mt={40}
            onClick={() => {
              history.push(LOGIN_URL);
            }}
            data-component-name="Log in button"
            type="button"
            withChevron
          >
            Sign in
          </ButtonV2>
        </Center>
      </CustomerAccountPage>
    </>
  );
}

export default SignupCompletePage;
